/**
 * Export component file to be used on project
 */

import ResetPassword from './ResetPassword';
export default ResetPassword;